export var loadgame = function loadgame(data) {
  return {
    type: 'LOAD_CS2N_DATA',
    data: data
  };
};
export var completedMilestone = function completedMilestone(game) {
  return {
    type: 'COMPLETE_MILESTONE',
    game: game
  };
};